/* eslint-disable no-nested-ternary */
import { Component, OnInit } from '@angular/core';
import { AuthStoreService, SiteLanguageStoreService, UserSettings } from '@motivforce/mx-library-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, take } from 'rxjs';
import { UserPartnerType } from 'src/app/core/enum/user-partner-type.enum';
import { Banner } from 'src/app/core/model/core/banner';
import { BannerStoreService } from 'src/app/core/store/banner-store.service';

import { MilestonesMode } from '../../../core/enum/milestones-mode';
import { Currency } from '../../../core/model/core/currency';
import { Milestone, MilestoneEmeaAndAus } from '../../../core/model/core/milestone';
import { User } from '../../../core/model/user';
import { MilestoneStoreService } from '../../../core/store/milestone-store.service';
import { UserStoreService } from '../../../core/store/user-store.service';

@UntilDestroy()
@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit {
  MilestonesMode = MilestonesMode;

  performance$ = this.milestoneStore.performanceMilestones$.pipe(filter(Boolean));
  currentPerformance: any;
  performanceCompletedLength = 0;
  banner: Banner;
  programName: string;
  mode: MilestonesMode = MilestonesMode.ALL;
  countryCode: string;
  hideMilestones = false;

  mspTrackerDesktopImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/msp-tracker-desktop.png';

  mspTrackerEmeaEuroDesktopImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/msp-emea-eur-tracker2-desktop.jpg';

  mspTrackerEmeaPoundDesktopImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/msp-emea-gbp-tracker2-desktop.jpg';

  mspTrackerEmeaNokSekDesktopImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2730_L360%20Boost_tracker_desktop_NOK%20SEK_72dpi_2.jpg';

  mspTrackerEmeaDKKDesktopImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2730_L360+Boost_tracker_desktop_KR_72dpi.jpg';

  mspTrackerEmeaCHFDesktopImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2831_L360_Boost_tracker_desktop_CHF_72dpi.jpg';

  mspTrackerMobileImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/msp-tracker-mobile.png';

  mspTrackerEmeaEuroMobileImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/msp-emea-eur-tracker2-mobile.jpg';

  mspTrackerEmeaEuroDesktopImageDE =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2850_L360+Boost_tracker_desktop_DE_72dpi.jpg';

  mspTrackerEmeaEuroMobileImageDE =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2850_L360+Boost_tracker_mobile_DE_72dpi.jpg';

  mspTrackerEmeaEuroDesktopImageIT =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2850_L360+Boost_tracker_desktop_IT_72dpi.jpg';

  mspTrackerEmeaEuroMobileImageIT =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2850_L360+Boost_tracker_mobile_IT_72dpi.jpg';

  mspTrackerEmeaEuroDesktopImageFR =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2850_L360+Boost_tracker_desktop_FR_72dpi.jpg';

  mspTrackerEmeaEuroMobileImageFR =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2850_L360+Boost_tracker_mobile_FR_72dpi.jpg';

  mspTrackerEmeaEuroDesktopImageES =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2850_L360+Boost_tracker_desktop_ES_72dpi.jpg';

  mspTrackerEmeaEuroMobileImageES =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2850_L360+Boost_tracker_mobile_ES_72dpi.jpg';

  mspTrackerEmeaPoundMobileImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/msp-emea-gbp-tracker2-mobile.jpg';

  mspTrackerEmeaNokSekMobileImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2730_L360%20Boost_tracker_desktop_NOK%20SEK_72dpi_2.jpg';

  mspTrackerEmeaDKKMobileImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2730_L360+Boost_tracker_mobile_KR_72dpi.jpg';

  mspTrackerEmeaCHFMobileImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/LUN2831_L360_Boost_tracker_mobile_CHF_72dpi.jpg';

  oemTrackerDesktopImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/oem-tracker-desktop.png';

  oemTrackerMobileImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/oem-tracker-mobile.png';

  ausTrackerMobileImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/Mobile_Milestone+bar+AUS_72.jpg';

  ausTrackerDesktopImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/Desktop_Milestone+bar+AUS_144.jpg';

  // check current name if updating the img
  noMilestonesDesktopImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/japan-banner-background.png';

  pointsTrackerImage =
    'url("https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/points-background.png")';

  pointsTrackerImageMobile =
    'url("https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/points-background-mobile.png")';

  // check current name if updating the img
  noMilestonesTrackerImage =
    'url("https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/japan_points_background.png")';

  lasBrTrackerDesktopImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/msp-las-br-tracker-desktop.png';

  lasBrTrackerMobileImage =
    'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/msp-las-br-tracker-mobile.png';

  trackerImage: string;
  trackerMobileImage: string;

  // This figures control the width per bar of progress for desktop/tablet and mobile.
  // It's multiplied depending of the completed milestone below.
  mspBarPixel = 42.8;
  mspEmeaBarPixel = 74.8;
  oemBarPixel = 33;
  mspBarMobilePixel = 55.6;
  mspEmeaBarMobilePixel = 103;
  oemBarMobilePixel = 42.5;
  ausBarPixel = 150.2;
  ausBarMobilePixel = 192;
  lasBrBarPixel = 74.8;
  lasBrBarMobilePixel = 100;

  barPixel = this.mspBarPixel;
  barMobilePixel = this.mspBarMobilePixel;
  barWidth = 0;
  barMobileWidth = 0;
  isOEM = false;

  currency: Currency;

  constructor(
    private userStore: UserStoreService,
    private authStore: AuthStoreService,
    private bannerStore: BannerStoreService,
    private milestoneStore: MilestoneStoreService,
    private siteLanguageStore: SiteLanguageStoreService
  ) {}

  ngOnInit(): void {
    this.milestoneStore.performanceMilestones$
      .pipe(untilDestroyed(this), filter(Boolean))
      .subscribe(() => this.setTrack());

    this.bannerStore.banner$.pipe(untilDestroyed(this), filter(Boolean)).subscribe((banner) => {
      this.banner = banner;
    });

    this.authStore.isRegularUser$.pipe(untilDestroyed(this), filter(Boolean)).subscribe(() => {
      const { user, country } = this.authStore.userSettings as UserSettings<User>;

      if (country) {
        this.countryCode = country.alpha2Code;
      }

      if (user?.region?.regionCode === 'EMEA') {
        this.mode = MilestonesMode.EMEA;
        this.programName = user.program.name;
      } else if (country.alpha2Code === 'AU') {
        this.mode = MilestonesMode.AUS;
      } else if (user?.region?.regionCode === 'LAS') {
        this.mode = MilestonesMode.LAS;
      } else if (user?.region?.regionCode === 'BR') {
        this.mode = MilestonesMode.BR;
      } else {
        this.mode = MilestonesMode.ALL;
      }

      this.setTrack();
    });

    this.userStore.currency$.pipe(untilDestroyed(this), filter(Boolean), take(1)).subscribe((currency) => {
      this.currency = currency;

      this.setTrack();
    });

    this.bannerStore.getBanner();
  }

  private setTrack(): void {
    // 2 countries without milestones
    if (this.countryCode === 'JP' || this.countryCode === 'NZ') {
      this.hideMilestones = true;
      this.trackerImage = this.noMilestonesDesktopImage;
      this.trackerMobileImage = this.noMilestonesDesktopImage;
    } else if (this.milestoneStore.performanceMilestones && this.currency) {
      const data = this.milestoneStore.performanceMilestones;

      if (data.partnerType === UserPartnerType.MSP_PARTNER_TYPE) {
        this.setTrackerImageMSP(this.mode, this.currency);
        this.barPixel = this.mode === MilestonesMode.EMEA ? this.mspEmeaBarPixel : this.mspBarPixel;
        this.barMobilePixel = this.mode === MilestonesMode.EMEA ? this.mspEmeaBarMobilePixel : this.mspBarMobilePixel;
        if (this.mode === MilestonesMode.AUS) {
          this.barPixel = this.ausBarPixel;
          this.barMobilePixel = this.ausBarMobilePixel;
        } else if (this.mode === MilestonesMode.LAS || this.mode === MilestonesMode.BR) {
          this.barPixel = this.lasBrBarPixel;
          this.barMobilePixel = this.lasBrBarMobilePixel;
        }
      } else {
        this.trackerImage = this.oemTrackerDesktopImage;
        this.trackerMobileImage = this.oemTrackerMobileImage;
        this.barPixel = this.oemBarPixel;
        this.barMobilePixel = this.oemBarMobilePixel;
        this.isOEM = true;
      }
      const performanceCompleted = (data.values as (Milestone | MilestoneEmeaAndAus)[]).filter(
        (value) => value.completed === true
      );

      this.performanceCompletedLength = performanceCompleted.length - 1;
      if (performanceCompleted) {
        this.barWidth = this.performanceCompletedLength * this.barPixel;
        this.barMobileWidth = this.performanceCompletedLength * this.barMobilePixel;
        this.currentPerformance = performanceCompleted.pop();
      }
    }
  }

  private setTrackerImageMSP(mode: MilestonesMode, currency: Currency): void {
    if (this.mode === MilestonesMode.EMEA) {
      switch (currency.isoCode) {
        case 'GBP':
          this.trackerImage = this.mspTrackerEmeaPoundDesktopImage;
          this.trackerMobileImage = this.mspTrackerEmeaPoundMobileImage;
          break;
        case 'DKK':
          this.trackerImage = this.mspTrackerEmeaDKKDesktopImage;
          this.trackerMobileImage = this.mspTrackerEmeaDKKMobileImage;
          break;
        case 'NOK':
        case 'SEK':
          this.trackerImage = this.mspTrackerEmeaNokSekDesktopImage;
          this.trackerMobileImage = this.mspTrackerEmeaNokSekMobileImage;
          break;
        case 'CHF':
          this.trackerImage = this.mspTrackerEmeaCHFDesktopImage;
          this.trackerMobileImage = this.mspTrackerEmeaCHFMobileImage;
          break;
        default:
          this.trackerImage = this.mspTrackerEmeaEuroDesktopImage;
          this.trackerMobileImage = this.mspTrackerEmeaEuroMobileImage;
          this.loadEmeaEuroBanner();
      }
    } else if (this.mode === MilestonesMode.AUS) {
      this.trackerImage = this.ausTrackerDesktopImage;
      this.trackerMobileImage = this.ausTrackerMobileImage;
    } else if (this.mode === MilestonesMode.LAS || this.mode === MilestonesMode.BR) {
      this.trackerImage = this.lasBrTrackerDesktopImage;
      this.trackerMobileImage = this.lasBrTrackerMobileImage;
    } else {
      this.trackerImage = this.mspTrackerDesktopImage;
      this.trackerMobileImage = this.mspTrackerMobileImage;
    }
  }

  loadEmeaEuroBanner() {
    if (this.siteLanguageStore.language === 'de-DE') {
      this.trackerImage = this.mspTrackerEmeaEuroDesktopImageDE;
      this.trackerMobileImage = this.mspTrackerEmeaEuroMobileImageDE;
    } else if (this.siteLanguageStore.language === 'it-IT') {
      this.trackerImage = this.mspTrackerEmeaEuroDesktopImageIT;
      this.trackerMobileImage = this.mspTrackerEmeaEuroMobileImageIT;
    } else if (this.siteLanguageStore.language === 'fr-FR') {
      this.trackerImage = this.mspTrackerEmeaEuroDesktopImageFR;
      this.trackerMobileImage = this.mspTrackerEmeaEuroMobileImageFR;
    } else if (this.siteLanguageStore.language === 'es-ES') {
      this.trackerImage = this.mspTrackerEmeaEuroDesktopImageES;
      this.trackerMobileImage = this.mspTrackerEmeaEuroMobileImageES;
    }
  }
}
